module.exports = __webpack_public_path__ + "static/media/hero_kenia_getty_tablet.fc408b4a.jpg";